import { InputAdornment, MenuItem, Stack, TextField } from "@mui/material";
import BookIcon from "@entrilia/shared/icons/BookIcon.tsx";
import useBalanceSheetContext from "../contexts/BalanceSheetContext.tsx";
import BalanceSheetEntityFilter from "./BalanceSheetEntityFilter.tsx";
import BalanceSheetPeriodPicker from "./BalanceSheetPeriodPicker.tsx";

const BalanceSheetToolbar = () => {
  const {
    isMultiBook,
    books,
    selectedAccountingBook,
    onAccountingBookChange,
    period,
    onPeriodChange,
    entityOptions,
    selectedEntity,
    onEntityChange,
  } = useBalanceSheetContext();

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
          {isMultiBook && (
            <TextField
              select
              size="small"
              value={selectedAccountingBook ?? ""}
              onChange={(event) => onAccountingBookChange(event.target.value || null)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <BookIcon fontSize="small" />
                    </InputAdornment>
                  ),
                },
              }}
              sx={{ minWidth: 220 }}
            >
              {books.map((book) => (
                <MenuItem key={book.code} value={book.code}>
                  {book.name}
                </MenuItem>
              ))}
            </TextField>
          )}

          <BalanceSheetPeriodPicker value={period} onChange={onPeriodChange} />

          <BalanceSheetEntityFilter options={entityOptions} value={selectedEntity} onChange={onEntityChange} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BalanceSheetToolbar;
